import React from 'react';
import ProductCard from './ProductCard';

/**
 * ProductGrid Component
 * Displays products in a responsive grid layout
 */
const ProductGrid = ({ products }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product, index) => (
        <div
          key={product.id}
          data-aos="fade-up"
          data-aos-delay={index * 50}
        >
          <ProductCard product={product} />
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
